import { render, staticRenderFns } from "./ParameterForm.vue?vue&type=template&id=aa45f5e8&"
import script from "./ParameterForm.vue?vue&type=script&lang=js&"
export * from "./ParameterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports